var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"[ c-status-ok ]"},[_c('svg',{staticClass:"[ o-icon ] [ c-status-ok__icon ]"},[_c('use',{attrs:{"xlink:href":"/img/icons.svg?v=fc89cbad7b#icon-check--circle"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }